<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <div class="home-title mt-4 card-title">
            People and Pleasures
            <v-btn text to="/">Go Back</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col>
          <v-card>
            <v-card-text
              class="body-1"
            >Throughout the years Welland Canals have provided many hours of recreation for many people.</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row wrap>
         <v-col lg="12" sm="12">
          <v-card>
            <v-img contain src="../assets/images/Photo_3___People_and_Pleasures_983_91_155_Pier_and_East_Light.jpg"></v-img>
<image-viewer source="Photo_3___People_and_Pleasures_983_91_155_Pier_and_East_Light.jpg"></image-viewer>
            <v-card-text class="body-1">People walking along the breakwall during the Third Canal era, with the ship Sultana passing through the harbour. On the east side of the canal you can see the inner lighthouse and the Grand Trunk elevator, c. 1890
Port Colborne Historical & Marine Museum 983.91.155</v-card-text>
          </v-card>
        </v-col>
        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Phorto_1__People__Pleasures_984_102_1_Fortier_Family.jpg"></v-img>
<image-viewer source="Phorto_1__People__Pleasures_984_102_1_Fortier_Family.jpg"></image-viewer>
            <v-card-text class="body-1">The Fortier family enjoying the beach at the south end of the canal, c. 1890.
 Port Colborne Historical & Marine Museum 984.102.1
 </v-card-text>
          </v-card>
        </v-col>

       

        <v-col lg="4" sm="12">
          <v-card>
            <v-img src="../assets/images/Photo_2___People__Pleasures_982_87_2_Boys_on_Canal.jpg"></v-img>
<image-viewer source="Photo_2___People__Pleasures_982_87_2_Boys_on_Canal.jpg"></image-viewer>
            <v-card-text class="body-1">Young boys sitting on the west side of the harbour, c. 1890.
Port Colborne Historical & Marine Museum 982.87.2</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img  src="../assets/images/Photo_4___People_and_Pleasures_Boat_excursion_2009_20_81.jpg"></v-img>
<image-viewer source="Photo_4___People_and_Pleasures_Boat_excursion_2009_20_81.jpg"></image-viewer>
            <v-card-text class="body-1">1920s photograph of a boat excursion on the canal showing Shickluna’s Garage in the background.
Port Colborne Historical & Marine Museum 2009.20.81</v-card-text>
          </v-card>
        </v-col>

        <v-col lg="4" sm="12">
          <v-card>
            <v-img  src="../assets/images/Photo_5__People_and_Pleasures_993_22_2.jpg"></v-img>
<image-viewer source="Photo_5__People_and_Pleasures_993_22_2.jpg"></image-viewer>
            <v-card-text class="body-1">Men playing hockey on the ice of the canal, c. 1900.
Port Colborne Historical & Marine Museum 993.22.2</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
export default {
  name: "PeoplePleasures",
  components: {},
};
</script>

<style>
</style>